(() => {
  const drawer = document.querySelector('[data-ox-cart-drawer]');
  if (!drawer || drawer.dataset.oxCartReady === 'true') return;
  drawer.dataset.oxCartReady = 'true';

  const cartMessages = {
    fr: {
      countOne: 'article',
      countOther: 'articles',
      decreaseQuantity: (title) => `Réduire la quantité de ${title}`,
      increaseQuantity: (title) => `Augmenter la quantité de ${title}`,
      removeItem: (title) => `Retirer ${title}`,
      remove: 'Retirer',
      opening: 'Ouverture du panier…',
      updating: 'Mise à jour du panier…',
      adding: 'Ajout au panier…',
      added: 'Pièce ajoutée au panier.',
      removed: 'Pièce retirée.',
      quantityUpdated: 'Quantité mise à jour.',
      loadError: 'Le panier n’a pas pu être chargé.',
      updateError: 'La mise à jour du panier a échoué.',
      inscriptionQuantity: 'Quantité fixée pour cette inscription. Retirez puis ajoutez de nouveau pour la modifier.'
    },
    en: {
      countOne: 'item',
      countOther: 'items',
      decreaseQuantity: (title) => `Decrease quantity of ${title}`,
      increaseQuantity: (title) => `Increase quantity of ${title}`,
      removeItem: (title) => `Remove ${title}`,
      remove: 'Remove',
      opening: 'Opening cart…',
      updating: 'Updating cart…',
      adding: 'Adding to cart…',
      added: 'Item added to cart.',
      removed: 'Item removed.',
      quantityUpdated: 'Quantity updated.',
      loadError: 'The cart could not be loaded.',
      updateError: 'The cart could not be updated.',
      inscriptionQuantity: 'Quantity fixed for this inscription. Remove and add again to change it.'
    },
    de: {
      countOne: 'Artikel',
      countOther: 'Artikel',
      decreaseQuantity: (title) => `Menge von ${title} verringern`,
      increaseQuantity: (title) => `Menge von ${title} erhöhen`,
      removeItem: (title) => `${title} entfernen`,
      remove: 'Entfernen',
      opening: 'Warenkorb wird geöffnet…',
      updating: 'Warenkorb wird aktualisiert…',
      adding: 'Wird zum Warenkorb hinzugefügt…',
      added: 'Artikel zum Warenkorb hinzugefügt.',
      removed: 'Artikel entfernt.',
      quantityUpdated: 'Menge aktualisiert.',
      loadError: 'Warenkorb konnte nicht geladen werden.',
      updateError: 'Warenkorb konnte nicht aktualisiert werden.',
      inscriptionQuantity: 'Menge für diese Inschrift festgelegt. Zum Ändern entfernen und erneut hinzufügen.'
    },
    zh: {
      countOne: '件商品',
      countOther: '件商品',
      decreaseQuantity: (title) => `减少「${title}」的数量`,
      increaseQuantity: (title) => `增加「${title}」的数量`,
      removeItem: (title) => `移除「${title}」`,
      remove: '移除',
      opening: '正在打开购物车…',
      updating: '正在更新购物车…',
      adding: '正在加入购物车…',
      added: '商品已加入购物车。',
      removed: '商品已移除。',
      quantityUpdated: '数量已更新。',
      loadError: '无法加载购物车。',
      updateError: '购物车更新失败。',
      inscriptionQuantity: '此铭刻组合的数量已固定；如需更改，请移除后重新添加。'
    }
  };
  const giftMessages = {
    fr: { label: 'Cadeau de bienvenue · offert', terms: 'Offre réservée à votre première commande livrée en France. Votre éligibilité est vérifiée au paiement. Si le gobelet n’est plus offert, retirez-le du panier avant de payer.' },
    en: { label: 'Welcome gift · free', terms: 'For your first order delivered in France. Eligibility is checked at checkout. If the cup is no longer free, remove it from your cart before paying.' },
    de: { label: 'Willkommensgeschenk · kostenlos', terms: 'Für Ihre erste Bestellung mit Lieferung nach Frankreich. Die Berechtigung wird an der Kasse geprüft. Falls der Becher nicht mehr kostenlos ist, entfernen Sie ihn vor der Zahlung aus dem Warenkorb.' },
    zh: { label: '首单赠礼 · 免费', terms: '限配送至法国的首单，结账时核实资格。如小杯不再免费，请返回购物车移除后再付款。' }
  };
  const giftMessage = giftMessages[document.documentElement.lang.split('-')[0]] || giftMessages.fr;
  const giftTerms = document.createElement('p');
  giftTerms.className = 'ox-cart__variant';
  giftTerms.dataset.oxGiftTerms = '';
  giftTerms.hidden = true;
  const messages = cartMessages[document.documentElement.lang.split('-')[0]] || cartMessages.fr;

  const engravingCopy={fr:{removeGroup:'Retirer la pièce et sa gravure'},en:{removeGroup:'Remove piece and engraving'},de:{removeGroup:'Stück und Gravur entfernen'},zh:{removeGroup:'移除器物及刻字'}};
  const engravingMessages=engravingCopy[document.documentElement.lang.split('-')[0]]||engravingCopy.fr;
  const lines = drawer.querySelector('[data-ox-cart-lines]');
  const empty = drawer.querySelector('[data-ox-cart-empty]');
  const footer = drawer.querySelector('[data-ox-cart-footer]');
  footer?.prepend(giftTerms);
  const subtotal = drawer.querySelector('[data-ox-cart-subtotal]');
  const status = drawer.querySelector('[data-ox-cart-status]');
  const error = drawer.querySelector('[data-ox-cart-error]');
  const closeButton = drawer.querySelector('.ox-cart__panel [data-ox-cart-close]');
  const routeRoot = window.Shopify?.routes?.root || '/';
  const route = (path) => `${routeRoot}${path}`.replace(/([^:]\/)\/+/g, '$1');
  let lastTrigger = null;
  let busy = false;
  let closeTimer;
  const panel = drawer.querySelector('.ox-cart__panel');
  panel.inert = true;

  const money = (cents, currency) => new Intl.NumberFormat(
    document.documentElement.lang || 'fr-FR',
    { style: 'currency', currency: currency || 'EUR' }
  ).format((Number(cents) || 0) / 100);

  const setError = (message = '') => {
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  };

  const setStatus = (message = '') => {
    if (status) status.textContent = message;
  };

  const updateCounts = (count) => {
    document.querySelectorAll('[data-ox-cart-count]').forEach((node) => {
      node.textContent = `${count}`;
      node.setAttribute('aria-label', `${count} ${count === 1 ? messages.countOne : messages.countOther}`);
    });
  };

  const control = (label, action, item, quantity) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.oxCartChange = action;
    button.dataset.key = item.key;
    button.dataset.quantity = String(quantity);
    button.setAttribute('aria-label', label);
    button.textContent = action === 'decrement' ? '−' : action === 'increment' ? '+' : messages.remove;
    if (action === 'remove') button.className = 'ox-cart__remove';
    return button;
  };

  const render = (cart) => {
    lines.replaceChildren();
    updateCounts(cart.item_count || 0);
    const hasItems = Array.isArray(cart.items) && cart.items.length > 0;
    empty.hidden = hasItems;
    footer.hidden = !hasItems;
    const hasGift = (cart.items || []).some(item => item.properties?._dos_gift === '1948155674967');
    giftTerms.hidden = !hasGift;
    giftTerms.textContent = hasGift ? giftMessage.terms : '';
    if (subtotal) subtotal.textContent = money(cart.total_price, cart.currency);

    (cart.items || []).forEach((item) => {
      const engravingParent = item.properties?._ox_service === 'inscription' ? (cart.items || []).find(line => line.key === item.parent_relationship?.parent_key) : null;
      const article = document.createElement('article');
      article.className = 'ox-cart__line';

      if (item.image) {
        const link = document.createElement('a');
        link.href = item.url;
        const image = document.createElement('img');
        const imageUrl = (width) => {
          const url = new URL(item.image, window.location.origin);
          url.searchParams.delete('height');
          url.searchParams.delete('crop');
          url.searchParams.set('width', String(width));
          return url.href;
        };
        image.src = imageUrl(270);
        image.srcset = [180, 270, 360].map((width) => `${imageUrl(width)} ${width}w`).join(', ');
        image.sizes = '(max-width: 1180px) 78px, 90px';
        image.alt = '';
        image.width = 90;
        image.height = 110;
        link.append(image);
        article.append(link);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'ox-cart__image-placeholder';
        article.append(placeholder);
      }

      const copy = document.createElement('div');
      copy.className = 'ox-cart__line-copy';
      const title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.product_title;
      copy.append(title);

      if (item.variant_title && item.variant_title !== 'Default' && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'ox-cart__variant';
        variant.textContent = item.variant_title;
        copy.append(variant);
      }

      Object.entries(item.properties || {}).forEach(([key,value]) => {
        if(!value || key.startsWith('_'))return;
        const property=document.createElement('p');property.className='ox-cart__variant';property.append(document.createTextNode(key+': '));
        let upload=false;try{const u=new URL(value);upload=u.protocol==='https:'&&u.hostname==='cdn.shopify.com'&&u.pathname.includes('/uploads/')&&/\.png$/i.test(u.pathname);}catch{}
        const propertyValue=document.createElement(upload?'a':'span');propertyValue.translate=false;
        if(upload){propertyValue.href=value;propertyValue.target='_blank';propertyValue.rel='noopener noreferrer';propertyValue.textContent=({fr:'Voir l’image',en:'View image',de:'Bild ansehen',zh:'查看图片'})[document.documentElement.lang.split('-')[0]]||'View image';}
        else propertyValue.textContent=value;property.append(propertyValue);copy.append(property);
      });
      const price = document.createElement('p');
      price.className = 'ox-cart__line-price';
      price.textContent = money(item.final_line_price, cart.currency);
      copy.append(price);
      if (item.properties?._dos_gift === '1948155674967' && item.final_line_price === 0) {
        const giftLabel = document.createElement('p');
        giftLabel.className = 'ox-cart__variant';
        giftLabel.textContent = giftMessage.label;
        copy.append(giftLabel);
      }

      const actions = document.createElement('div');
      actions.className = 'ox-cart__line-actions';
      const stepper = document.createElement('div');
      stepper.className = 'ox-cart__stepper';
      stepper.append(
        control(messages.decreaseQuantity(item.product_title), 'decrement', item, Math.max(0, item.quantity - 1)),
        Object.assign(document.createElement('span'), { textContent: String(item.quantity) }),
        control(messages.increaseQuantity(item.product_title), 'increment', item, item.quantity + 1)
      );
      if (item.properties?._dos_gift === '1948155674967') {
        stepper.querySelectorAll('button').forEach(button => button.disabled = true);
      }
      if (item.properties?._ox_inscription) {
        stepper.querySelectorAll('button').forEach(button=>button.disabled=true);
        stepper.title = messages.inscriptionQuantity;
      }
      const removal = control(messages.removeItem(item.product_title), 'remove', engravingParent || item, 0);
      if (item.properties?._ox_inscription) {
        const note=document.createElement('p');note.className='ox-cart__variant';note.textContent=messages.inscriptionQuantity;copy.append(note);
      }
      if (engravingParent) {
        removal.textContent=engravingMessages.removeGroup;
        removal.setAttribute('aria-label',engravingMessages.removeGroup);
      }
      actions.append(stepper, removal);
      copy.append(actions);
      article.append(copy);
      lines.append(article);
    });
  };

  const requestJson = async (url, options = {}, fallback = messages.updateError) => {
    const response = await fetch(url, { headers: { Accept: 'application/json', ...(options.headers || {}) }, ...options });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || fallback);
    return data;
  };

  let giftRefreshTimer;
  const refreshAfterGiftAdjustment = () => {
    clearTimeout(giftRefreshTimer);
    if (busy) {
      giftRefreshTimer = setTimeout(refreshAfterGiftAdjustment, 100);
      return;
    }
    void loadCart().catch((requestError) => setError(requestError.message));
  };
  document.addEventListener('dos:gift_adjustments', refreshAfterGiftAdjustment);

  const loadCart = async () => {
    const cart = await requestJson(route('cart.js'), {}, messages.loadError);
    render(cart);
    return cart;
  };

  const open = (trigger) => {
    clearTimeout(closeTimer);
    lastTrigger = trigger || document.activeElement;
    document.querySelector('orienx-mobile-search')?.close(false, true);
    panel.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ox-cart-open');
    document.dispatchEvent(new CustomEvent('ox:cart-toggle', { detail: { open: true } }));
    const visibleClose = [...drawer.querySelectorAll('[data-ox-cart-close]')].find(el => el.tabIndex >= 0 && el.getClientRects().length);
    (visibleClose || panel)?.focus({ preventScroll: true });
  };

  const close = () => {
    panel.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ox-cart-open');
    document.dispatchEvent(new CustomEvent('ox:cart-toggle', { detail: { open: false } }));
    clearTimeout(closeTimer);
    const restore = () => {
      const fallback = [...document.querySelectorAll('[data-ox-cart-open]')].find(el => el.getClientRects().length);
      const target = lastTrigger?.getClientRects?.().length ? lastTrigger : fallback;
      target?.focus?.({ preventScroll: true });
    };
    const delay = window.innerWidth <= 1180 && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 480 : 0;
    closeTimer = setTimeout(restore, delay);
  };

  const change = async (key, quantity) => {
    if (busy) return;
    busy = true;
    setError();
    setStatus(messages.updating);
    try {
      const cart = await requestJson(route('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      render(cart);
      setStatus(quantity === 0 ? messages.removed : messages.quantityUpdated);
    } catch (requestError) {
      setError(requestError.message);
      setStatus();
    } finally {
      busy = false;
    }
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-ox-cart-open]');
    if (opener) {
      event.preventDefault();
      setError();
      setStatus(messages.opening);
      try {
        await loadCart();
        setStatus();
        open(opener);
      } catch (requestError) {
        window.location.assign(opener.href);
      }
      return;
    }

    if (event.target.closest('[data-ox-cart-close]')) {
      close();
      return;
    }

    const changer = event.target.closest('[data-ox-cart-change]');
    if (changer) {
      const { key, oxCartChange: action } = changer.dataset;
      const restoreFocus = document.activeElement === changer;
      await change(key, Number(changer.dataset.quantity));
      if (restoreFocus && drawer.getAttribute('aria-hidden') === 'false') {
        const replacement = [...lines.querySelectorAll('[data-ox-cart-change]')].find(el => el.dataset.key === key && el.dataset.oxCartChange === action);
        (replacement || panel)?.focus({ preventScroll: true });
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (drawer.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const items = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  });

  document.querySelectorAll('[data-ox-product-form]').forEach((form) => {
    form.dataset.oxEngravingReady='true';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy) return;
      busy = true;
      const submit = form.querySelector('[type="submit"]');
      const productError = form.querySelector('[data-ox-product-error]');
      submit?.setAttribute('aria-busy', 'true');
      if (productError) { productError.hidden = true; productError.textContent = ''; }
      try {
        const formData = new FormData(form);
        const inscription=[...document.querySelectorAll('orienx-engraving-preview')].find(component=>component.dataset.formId===form.getAttribute('id'))||form.querySelector('orienx-inscription');
        const payload=inscription?.cartPayload?await inscription.cartPayload(formData):null;
        const items=inscription?.cartPayload?null:inscription?.items(formData);
        if(payload){
          await requestJson(route('cart/add.js'),{method:'POST',body:payload});
        } else if(items){
          await requestJson(route('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        } else {
          await requestJson(route('cart/add.js'), { method: 'POST', body: formData });
        }
        await loadCart();
        setStatus(messages.added);
        open(submit);
      } catch (requestError) {
        if (productError) {
          productError.textContent = requestError.message;
          productError.hidden = false;
        }
      } finally {
        submit?.removeAttribute('aria-busy');
        busy = false;
      }
    });
  });
})();
